import { useState } from "react";
import {
  PasswordComponent,
  UserNameComponent,
} from "./loginComponent/LoginValidateComponent";
import Swal from "sweetalert2";
import { GetProfileService, LoginService } from "../../services/MainScreen";
import {
  SetCookie_Phone,
  SetCookie_Token,
  setFullNameCookie,
  setImageUrlCookie,
} from "../../utility/Cookies";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  CHANGE_PASSWORD_URL_LOCAL,
  HOME_URL_LOCAL,
  REGISTER_URL_LOCAL,
} from "../../utility/BaseUrl";

const Login = () => {
  const [setsignInLoading, setSetsignInLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const LoginForm = async () => {
    if (phone.length !== 11) {
      Swal.fire({
        icon: "error",
        title: "خطا",
        text: "شماره موبایل باید 11 رقم باشد.",
        confirmButtonText: "باشه",
      });
      return;
    } else if (password.length < 6) {
      Swal.fire({
        icon: "error",
        title: "خطا",
        text: "رمز عبور باید حداقل 6 کاراکتر باشد.",
        confirmButtonText: "باشه",
      });
      return;
    } else {
      setSetsignInLoading(true);
      const response = await LoginService(password, phone);
      if (response.status === 401)
        Swal.fire({
          icon: "error",
          title: "خطا!",
          text: response?.error?.response?.data?.detail,
          confirmButtonText: "باشه",
        });
      else if (response && response.access) {
        SetCookie_Token(response.access);

        const responseProfile = await GetProfileService();
        if (responseProfile.status === 200) {
          const { name, family, image } = responseProfile.result;
          let fullname = name + " " + family;
          setFullNameCookie(fullname);
          SetCookie_Phone(phone);
          setImageUrlCookie(image);

          Swal.fire({
            icon: "success",
            title: "ورود موفق",
            text: "شما با موفقیت وارد شدید.",
            confirmButtonText: "باشه",
          }).then(() => {
            const redirectPath = new URLSearchParams(location.search).get(
              "redirect"
            );
            navigate(redirectPath || HOME_URL_LOCAL);
          });
        } else
          Swal.fire({
            icon: "error",
            title: "خطا",
            text: "شما در ظاهر لاگین هستید!",
            confirmButtonText: "باشه",
          });
      } else {
        Swal.fire({
          icon: "error",
          title: "خطا",
          text: "ورود ناموفق بود!",
          confirmButtonText: "باشه",
        });
      }
      setSetsignInLoading(false);
    }
  };

  return (
    <>
      <main className="page-container signin-container" itemProp="mainEntity">
        <div className="container">
          <div className="row">
            <div className="col-3"></div>
            <div className="col-12 col-md-6">
              <h1
                className="page-title pb-20 mt-3 signin-title pt-20 pt-md-25  pt-lg-30  text-center w-100"
                itemProp="headline"
              >
                ورود به وب‌سایت
              </h1>
              {/* <span className="text-center w-100 d-none d-md-block pb-20">
                اطلاعات کاربری خود را در فیلدهای زیر بنویسید و وارد شوید
              </span> */}
              <div className="page-context signin-context text-center">
                <form
                  name="signin"
                  className="signin-form py-25 py-sm-30 py-md-35 pt-lg-10 pb-lg-10"
                  onSubmit={function (event) {
                    event.preventDefault();
                    LoginForm();
                  }}
                >
                  <UserNameComponent phone={phone} setPhone={setPhone} />
                  <PasswordComponent
                    password={password}
                    setPassword={setPassword}
                  />
                  <div className="row form-group signin-rememberme mt-20">
                    <div className="col-12 col-md-6 mt-2">
                      {/* <div className="custom-control custom-checkbox text-center text-md-right">
                        <input
                          type="checkbox"
                          id="signin-rememberme"
                          name="rememberme"
                          className="custom-control-input signin-rememberme-input"
                        />
                        <label
                          className="custom-control-label signin-rememberme-label text-xs"
                          for="signin-rememberme"
                        >
                          من را به خاطر بسپار
                        </label>
                      </div> */}
                    </div>
                    <div className="ccol-12 col-md-6 mt-2">
                      <button
                        type="button"
                        onClick={LoginForm}
                        className="btn btn-lg btn-primary signin-submit shadow"
                        style={{ padding: "0.4625rem 1.1875rem" }}
                      >
                        ورود به وب‌سایت
                      </button>
                      <div
                        className={
                          "page-loading signin-loading" +
                          (setsignInLoading ? "" : " d-none")
                        }
                      >
                        <i className="fa fa-refresh fa-spin fa-fw" />
                        کمی‌صبر‌کنید...
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="container">
                <div className="row form-group mb-0 mt-10 p-10 bg-white align-items-center text-md-right rounded">
                  <div className="col-12 col-md-6"> عضویت در سایت </div>
                  <div className="col-12 col-md-6 text-center text-md-left">
                    <Link
                      to={REGISTER_URL_LOCAL}
                      className="signin-signup btn mt-10 mt-md-1"
                      style={{ padding: "0.4625rem 1.1875rem" }}
                    >
                      ثبت‌نام کنید.
                    </Link>
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="row mt-2 form-group mb-0 mt-10 align-items-center p-10 bg-white text-md-right rounded">
                  <div className="col-12 col-md-6">
                    رمز عبور خود را فراموش کرده‌اید؟
                  </div>
                  <div className="col-12 col-md-6 text-center text-md-left">
                    <Link
                      to={CHANGE_PASSWORD_URL_LOCAL}
                      className="signin-signupb btn mt-10 mt-md-1"
                      style={{ padding: "0.4625rem 1.1875rem" }}
                    >
                      بازیابی رمز عبور
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-3"></div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Login;
